import { render, staticRenderFns } from "./CloseBtn.vue?vue&type=template&id=6983fcfc&scoped=true&lang=pug"
import script from "./CloseBtn.vue?vue&type=script&lang=js"
export * from "./CloseBtn.vue?vue&type=script&lang=js"
import style0 from "./CloseBtn.vue?vue&type=style&index=0&id=6983fcfc&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6983fcfc",
  null
  
)

export default component.exports